import { render } from "./Create25Liquidation1.vue?vue&type=template&id=a25045a0"
import script from "./Create25Liquidation1.vue?vue&type=script&lang=js"
export * from "./Create25Liquidation1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__